import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useDroppable } from "@dnd-kit/core";

import BoardIssueCard from "./BoardIssueCard";
import { STATUS_CATEGORY_COLORS } from "../../constants/projects.constants";

import type {
  Issue,
  Status,
} from "../../../../core/data/redux/projects/types";

interface BoardColumnProps {
  status: Status;
  issues: Issue[];
  projectKey: string;
  onCreateIssueClick: (statusId: number) => void;
}

const BoardColumn: React.FC<BoardColumnProps> = ({
  status,
  issues,
  projectKey,
  onCreateIssueClick,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `column-${status.id}`,
    data: { statusId: status.id, columnDroppable: true },
  });

  const itemIds = issues.map((i) => `issue-${i.id}`);

  return (
    <div
      className="d-flex flex-column"
      style={{
        minWidth: 280,
        maxWidth: 320,
        flex: "0 0 300px",
        background: isOver ? "#eff6ff" : "#f9fafb",
        borderRadius: 8,
        border: isOver ? "2px dashed #3B82F6" : "2px solid transparent",
        transition: "background .15s, border-color .15s",
      }}
    >
      <div className="px-3 py-2 d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <span
            className="d-inline-block rounded-circle"
            style={{
              width: 8,
              height: 8,
              background: status.color || STATUS_CATEGORY_COLORS[status.category],
            }}
          />
          <span className="fw-semibold text-uppercase small text-muted">
            {status.name}
          </span>
          <span className="text-muted small">{issues.length}</span>
        </div>
      </div>

      <div
        ref={setNodeRef}
        className="px-2 pb-2 flex-grow-1"
        style={{ minHeight: 200 }}
      >
        <SortableContext
          items={itemIds}
          strategy={verticalListSortingStrategy}
        >
          {issues.map((issue) => (
            <BoardIssueCard
              key={issue.id}
              issue={issue}
              projectKey={projectKey}
            />
          ))}
        </SortableContext>

        <button
          type="button"
          className="btn btn-sm btn-outline-info w-100 mt-1"
          onClick={() => onCreateIssueClick(status.id)}
        >
          <i className="ti ti-plus me-1" />
          Create issue
        </button>
      </div>
    </div>
  );
};

export default BoardColumn;
